import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PopularPlaceEditRequestBody, PopularPlaceEditResponse } from "./types";

export class PopularPlaceEditAPI extends BaseAPI<
    PopularPlaceEditRequestBody,
    PopularPlaceEditResponse
> {
    protected route = ApiRoutes.popular_place.edit;
    protected method = RequestMethod.PUT;
    protected params = ["id"]
}
